import { render, staticRenderFns } from "./medpagetoday.vue?vue&type=template&id=27bb48e8&scoped=true&v-once=true"
import script from "./medpagetoday.vue?vue&type=script&lang=js"
export * from "./medpagetoday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb48e8",
  null
  
)

export default component.exports